// extracted by mini-css-extract-plugin
module.exports = {"root":"_6sPYo","copyright":"_2BckJ","navigation":"_1WeK5"};